<owl-carousel
     [options]="{items: 3, dots: false, navigation: true, autoplay: true,
        autoplayTimeout: 2000, loop: true}"
     [items]="Images"
     [carouselClasses]="['owl-theme', 'row', 'sliding']">
     <div class="item" *ngFor="let item of Images;let i = index">
         <div class="thumbnail-image"></div>
         <img src="{{ item.image }}" class="img-fluid" alt="client-img" />
     </div>
 </owl-carousel>